<template>
  <div class="redemption-records" v-if="orderList">
    <Header />

    <div class="records-main">
      <div class="title">आर्डर इतिहास</div>
      <div class="picker">
        <div class="filtering">तिथि फ़िल्टर</div>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="to"
          start-placeholder="प्रारंभ तिथि"
          end-placeholder="समाप्त तिथि"
          size="mini"
          @change="changePicker"
          popper-class="picker-date-style"
          value-format="yyyy-MM-dd"
        >
          <el-date-picker v-model="value1" type="date" placeholder="तारीख चुनें">
          </el-date-picker>
        </el-date-picker>
      </div>
      <div class="list-fa" v-if="orderList.length !== 0">
        <div class="list-title">
          <div>तिथि</div>
          <div>उपहार का नाम</div>
          <div>राशि</div>
          <div>स्थिति</div>
          <div>नोट्स</div>
        </div>

        <div class="list">
          <div
            class="list-item"
            v-for="(item, index) in orderList"
            :key="index"
          >
            <div>{{ item.confirmDate }}</div>
            <div>{{ item.giftName }}</div>
            <div>$ {{ item.displayPoints | getDollar }}</div>
            <div>
              <span
                style="color: #698af7"
                v-if="item.status === 'Waiting for approve'"
                >{{ item.status }}</span
              >
              <span
                style="color: #81e0af"
                v-else-if="item.status === 'System approved'"
                >{{ item.status }}</span
              >
              <span
                style="color: #fa7692"
                v-else-if="item.status === 'System rejected'"
                >{{ item.status }}</span
              >
              <span style="color: #fa7692" v-else>{{ item.status }}</span>
            </div>

            <div>{{ item.memo ? item.memo : "-" }}</div>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="orderList.length !== 0">
        <el-pagination
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalSize"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>

      <div class="no-data" v-if="orderList.length === 0">कोई डेटा उपलब्ध नहीं है</div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import { Orders } from "@/api/api.js";
import { Notify } from "vant";
export default {
  filters: {
    getDollar: (data) => {
      let number = (data / 100).toFixed(2);
      return number;
    },
  },
  components: { Header, Footer },
  data() {
    return {
      currentPage: 1,
      oldPage: null,
      pageSize: 10,
      totalSize: null,
      orderList: null,
      value1: "",
      minDate: "",
      maxDate: "",
    };
  },
  methods: {
    currentChange(e) {
      this.currentPage = e;
      this.getOrderList();
    },
    getOrderList() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
        page: this.currentPage,
        size: this.pageSize,
        minDate: this.minDate,
        maxDate: this.maxDate,
      };
      Orders(params).then((res) => {
        if (res.code === 200) {
          console.log(res);
          this.orderList = res.data.list;
          this.totalSize = res.data.pagebar.totalSize;
        } else {
          Notify({ type: "warning", message: res.errors });
        }
      });
    },
    changePicker() {
      console.log(this.value1);
      if (this.value1) {
        this.minDate = this.value1[0];
        this.maxDate = this.value1[1];
      } else {
        this.minDate = "";
        this.maxDate = "";
      }
      this.getOrderList();
    },
  },
  created() {
    this.getOrderList();
  },
};
</script>
<style scoped>
.redemption-records {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.records-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
}
.records-main .title {
  font-size: 10px;
  font-weight: bold;
  color: #232323;
  font-size: 13px;
  margin-bottom: 20px;
}
.list-title {
  display: flex;
  justify-content: space-between;
  background-color: #f2f2f2;
}
.list-title > div {
  width: 100px;
  font-size: 10px;

  line-height: 22px;
  text-align: center;
}
.list {
  min-height: 300px;
}
.list-item {
  display: flex;
  justify-content: space-between;
}
.list-item > div {
  width: 100px;
  font-size: 10px;
  margin-top: 20px;
  text-align: center;
}
.pagination {
  display: flex;
  justify-content: center;
}
.el-pagination {
  margin-top: 40px;
}
.list-fa {
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
}
.no-data {
  font-size: 13px;
  color: #8e9c9c;
  font-weight: bold;
  text-align: center;
  margin-top: 50px;
}
</style>
<style scoped>
/* 媒体查询 */
@media only screen and (max-width: 1280px) {
  .records-main {
    width: calc(100% - 95px);
    padding: 20px 47.5px;
  }
}
@media only screen and (max-width: 1100px) {
  .records-main {
    width: calc(100% - 40px);
    padding: 20px 20px;
  }
}
@media only screen and (max-width: 1000px) {
  .list-title,
  .list {
    min-width: 625px;
  }
}
</style>
<style scoped>
.picker {
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}
.filtering {
  font-size: 10px;
  font-weight: bold;
  margin-right: 20px;
}
</style>
<style >
.picker-date-style {
  transform: scale(0.8);
}
@media only screen and (max-width: 960px) {
  .picker-date-style {
    width: 100vw !important;
    overflow-x: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/orderHistory.vue